import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { useToast } from '@/components/base/ToastProvider';
import { collections } from '@/mocks/home';

export default function CollectionSection() {
  const { showToast } = useToast();

  return (
    <section id="collection" className="scroll-mt-header w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <Reveal>
          <SectionHeading
            index="02"
            eyebrow="Full Collection"
            title="全网合集 · 一次看全整条线"
            desc="榜单看的是当下热度，合集看的是完整脉络。同一类争议从第一条发声到最后一次回应，按时间顺序串成可追溯的整理记录。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
                <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                  <img
                    src={item.cover}
                    alt={`${item.title} 热点黑料合集封面`}
                    title={`${item.title} 热点黑料合集 最全整理`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-3 py-1 text-[11px] font-semibold text-primary-700">
                    {item.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/80 px-2.5 py-1 text-[11px] font-medium text-background-50">
                    共 {item.episodes} 期
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 flex-1 text-[13px] leading-6 text-foreground-600">{item.desc}</p>
                  <div className="mt-5 flex items-center justify-between gap-3 border-t border-background-200/70 pt-4">
                    <span className="text-[11px] text-foreground-500">{item.updatedAt}</span>
                    <button
                      type="button"
                      onClick={() => showToast('合集内容正在按时间线整理，稍后即可查看完整记录')}
                      className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200"
                    >
                      查看合集
                      <i className="ri-arrow-right-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}